export enum SubMenuAccordionBlock {
  Root = 'SubMenuAccordion',
}

export enum SubMenuAccordionElement {
  Item = 'item',
}
